var scrollTicking = false;
window.addEventListener('scroll', function() {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function() {
        scrolled();
        scrollTicking = false;
    });
}, { passive: true });

document.addEventListener("wishlist-hero-wishlist-sdk-ready", async function(e) {

    if (typeof window.WishListHero_SDK === 'undefined') return;
    var countEl = document.querySelector(".wishlist-hero-items-count");
    if (!countEl) return;

    var wishlist_item_count = window.WishListHero_SDK.GetWishListItemsCount();
    countEl.style.display = wishlist_item_count > 0 ? "block" : "none";
    countEl.innerHTML = wishlist_item_count;

    setTimeout(function() {
        var wishlistIconSvg = '<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.4578 2.50292C18.9691 2.02645 18.3889 1.64848 17.7503 1.39061C17.1117 1.13273 16.4272 1 15.7359 1C15.0446 1 14.3601 1.13273 13.7215 1.39061C13.0829 1.64848 12.5026 2.02645 12.0139 2.50292L10.9997 3.4913L9.98554 2.50292C8.99842 1.54094 7.6596 1.0005 6.26361 1.0005C4.86761 1.0005 3.52879 1.54094 2.54168 2.50292C1.55456 3.46491 1 4.76964 1 6.1301C1 7.49055 1.55456 8.79529 2.54168 9.75727L3.55588 10.7457L10.9997 18L18.4436 10.7457L19.4578 9.75727C19.9467 9.28102 20.3346 8.71557 20.5992 8.0932C20.8638 7.47084 21 6.80377 21 6.1301C21 5.45642 20.8638 4.78935 20.5992 4.16699C20.3346 3.54463 19.9467 2.97917 19.4578 2.50292Z" stroke="#313131" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        var wishlistIconSvgLarge = '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.9952 3.36109C24.3599 2.63237 23.6056 2.0543 22.7754 1.6599C21.9451 1.2655 21.0553 1.0625 20.1566 1.0625C19.258 1.0625 18.3681 1.2655 17.5379 1.6599C16.7077 2.0543 15.9534 2.63237 15.3181 3.36109L13.9997 4.87273L12.6812 3.36109C11.3979 1.88982 9.65749 1.06326 7.84269 1.06326C6.0279 1.06326 4.28743 1.88982 3.00418 3.36109C1.72092 4.83236 1 6.82784 1 8.90853C1 10.9892 1.72092 12.9847 3.00418 14.456L4.32264 15.9676L13.9997 27.0625L23.6767 15.9676L24.9952 14.456C25.6308 13.7276 26.1349 12.8628 26.4789 11.9109C26.8229 10.9591 27 9.93885 27 8.90853C27 7.87821 26.8229 6.85798 26.4789 5.90613C26.1349 4.95428 25.6308 4.08947 24.9952 3.36109Z" stroke="#313131" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        var wishlistIconTargets = [
            { selector: '.size_popup-parent .wishlist-hero-custom-button.wishlisthero-floating button', svg: wishlistIconSvg },
            { selector: '.cart-item .wishlist-hero-custom-button.wishlisthero-floating button', svg: wishlistIconSvg },
            { selector: '.product-title-wishlist-wrapp .wishlist-hero-custom-button.wishlisthero-floating button', svg: wishlistIconSvgLarge },
            { selector: '.searchWishList .wishlist-hero-custom-button.wishlisthero-floating button', svg: wishlistIconSvg },
            { selector: '.shopwishListbtn .wishlist-hero-custom-button.wishlisthero-floating button', svg: wishlistIconSvg }
        ];
        wishlistIconTargets.forEach(function(target) {
            document.querySelectorAll(target.selector).forEach(function(btn) {
                btn.innerHTML = target.svg;
            });
        });
    }, 4000);
});

function scrolled() {
    document.body.classList.toggle("announcement-hide", window.scrollY > 0);
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

var navListElements = document.querySelectorAll('.navList');
if (navListElements.length) {
    navListElements.forEach((elm) => {
        elm.addEventListener('mouseenter', (target) => {
            var megaMenu = target.target.querySelector('.mega-menu');
            if (!megaMenu) return;
            target.preventDefault();
            target.currentTarget.closest('.navList').classList.add('active');
            megaMenu.setAttribute('open', 'open');
            document.body.classList.add("NavActive");

            var sidebarImages = target.target.querySelector('.sidebar_images_wrapp');
            if (sidebarImages && !sidebarImages.classList.contains("swiper-container-initialized")) {
                new Swiper(sidebarImages, {
                    loop: false, slidesPerView: 2, spaceBetween: 10, autoplay: { delay: 5000 },
                    breakpoints: { 1920: { slidesPerView: 2, spaceBetween: 10 }, 1028: { slidesPerView: 2, spaceBetween: 10 }, 480: { slidesPerView: 1, spaceBetween: 10 } }
                });
            }
        });
        elm.addEventListener('mouseleave', (target) => {
            var megaMenu = target.target.querySelector('.mega-menu');
            if (!megaMenu) return;
            target.currentTarget.closest('.navList').classList.remove('active');
            megaMenu.removeAttribute('open');
            document.body.classList.remove("NavActive");
        });
    });
}

document.addEventListener('DOMContentLoaded', function() {

    function checkSizePopups() {
        document.querySelectorAll(".size_popup-parent").forEach(function(element) {
            var inputLabelWrappers = element.querySelectorAll(".MainVariants .input-label-wrapper");
            var visibleElementsCount = 0;
            inputLabelWrappers.forEach(function(inputLabelWrapper) {
                var style = window.getComputedStyle(inputLabelWrapper);
                if (style.display !== 'none') {
                    visibleElementsCount++;
                }
            });
            if (visibleElementsCount === 0) {
                var popupElement = element.querySelector(".product_listing_sizes-popup");
                if (popupElement) {
                    popupElement.style.display = "none";
                }
            }
        });
    }
    if ('requestIdleCallback' in window) {
        requestIdleCallback(checkSizePopups, { timeout: 2000 });
    } else {
        setTimeout(checkSizePopups, 500);
    }

    scrolled();

    var getslider = document.querySelector('.HiddenSlider');
    var cartList = document.querySelector('.CartProduct_List');
    var getdata = document.querySelector('.MainEmpty_Bag');
    var emptyBagPro = document.querySelector('.EmptyBag_pro');
    if (getslider && cartList) {
        cartList.innerHTML = '<div class="Outer_ProductLists">' + getslider.innerHTML + '</div>';
    }
    if (getdata && emptyBagPro) {
        emptyBagPro.innerHTML = '<div class="MainEmpty_Bag">' + getdata.innerHTML + '</div>';
    }

    function isIE() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE ');
        const trident = ua.indexOf('Trident/');
        return msie > 0 || trident > 0;
    }

    if (isIE()) {
        var cartForm = document.querySelector('#cart');
        var cartSubmitBtn = document.querySelector('#checkout');
        if (cartForm && cartSubmitBtn) {
            const cartSubmitInput = document.createElement('input');
            cartSubmitInput.setAttribute('name', 'checkout');
            cartSubmitInput.setAttribute('type', 'hidden');
            cartForm.appendChild(cartSubmitInput);
            cartSubmitBtn.addEventListener('click', function(event) {
                cartForm.submit();
            });
        }
    }

    var logoSwiperEl = document.querySelector('.inner-logos-wrapper.swiper-container');
    if (logoSwiperEl) {
        new Swiper(logoSwiperEl, {
            freeMode: false,
            loop: false,
            slidesPerView: 4,
            spaceBetween: 50,
            pagination: {
                el: '.slider__pagination',
                clickable: true,
            },
            breakpoints: {
                1025: { slidesPerView: 4, spaceBetween: 50 },
                768: { slidesPerView: 4, spaceBetween: 50 },
                320: { slidesPerView: 2, spaceBetween: 20 }
            }
        });
    }

    document.querySelectorAll('.shplookprdtinCnt .CustomImage').forEach(function(item) {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            var colorSwatch = this.querySelector('.ColorGroupVrnt');
            if (!colorSwatch) return;
            document.querySelectorAll('.ColorGroupVrnt').forEach(function(color) {
                color.classList.remove('active');
            });
            colorSwatch.classList.add('active');
        });
    });

    switcher();
    function switcher() {
        if (window.innerWidth < 990) {
            var doublyWrapper = document.querySelector(".doubly-wrapper");
            var mobileLocalizationWrapper = document.querySelector(".mobile-localization-wrapper");
            if (doublyWrapper && mobileLocalizationWrapper) {
                mobileLocalizationWrapper.parentNode.insertBefore(doublyWrapper, mobileLocalizationWrapper.nextSibling);
                doublyWrapper.style.display = "block";
            }
        }
    }

});

function handleChange(e) {
    if (!e.target.closest(".MainVariants .input-label-wrapper input")) return;

    var sizeOptionWrapper = e.target.closest(".size_option_wrapper-popup");
    var productsVariants = e.target.closest(".product_listing_sizes-popup");
    if (!sizeOptionWrapper || !productsVariants) return;

    var text = '';
    var variantOptions = sizeOptionWrapper.querySelectorAll(".input-label-wrapper input");
    variantOptions.forEach(function(input) {
        if (input.checked) {
            text += input.value + " / ";
        }
    });
    var newname = text.slice(0, -3).trim();

    var variant_id;
    var inputs = productsVariants.querySelectorAll("input");
    inputs.forEach(function(input) {
        if (input.checked) {
            var option = productsVariants.querySelector('.hiddenSelector option[variant-title="' + newname + '"]');
            if (option) {
                variant_id = option.value;
            }
        }
    });
    if (!variant_id) return;

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
            if (window.FlexyPeCart && typeof window.FlexyPeCart.open === 'function') {
                window.FlexyPeCart.open();
            }
        }
    };
    xhr.send(JSON.stringify({
        id: variant_id,
        quantity: 1
    }));
}

var elements = document.querySelectorAll(".first_menu_data");
elements.forEach(function(element) {
    element.addEventListener("click", function() {
        var parentLi = findParentLi(element);
        if (parentLi) {
            var isActive = parentLi.classList.contains("activemonile-menu");
            var mainLiLists = document.querySelectorAll(".has-submenu .mainLiList");
            mainLiLists.forEach(function(mainLiList) {
                mainLiList.classList.remove("activemonile-menu");
            });
            if (!isActive) {
                parentLi.classList.add("activemonile-menu");
            }
        }
    });
});

function findParentLi(element) {
    var parent = element.parentNode;
    while (parent) {
        if (parent.tagName && parent.tagName.toLowerCase() === "li") {
            return parent;
        }
        parent = parent.parentNode;
    }
    return null;
}

document.addEventListener("click", function(event) {
    var target = event.target;
    if (target.closest(".recent_serches_wrapper .rpeated_recentsearches")) {
        var dataValue = target.closest(".rpeated_recentsearches").getAttribute("data-value");
        var searchInput = document.querySelector("input#Search-In-Template");
        var searchInput2 = document.querySelector("input#Search-In-Modal");
        var searchButton = document.querySelector("button.search__button.field__button");
        if (searchInput) {
            searchInput.value = dataValue;
            if (searchButton) searchButton.click();
        }
        if (searchInput2) {
            searchInput2.value = dataValue;
            if (searchButton) searchButton.click();
        }
        return;
    }

    if (target.classList.contains('ViewText')) {
        var cartFooter = document.querySelector('.desktop_subpopu');
        if (cartFooter) {
            cartFooter.classList.toggle('Active_Summary');
        }
        return;
    }

    handleChange(event);

    if (target.closest('.image_upper_cartbtn .product_upper_cart-trigger svg')) {
        var sizePopupParent = target.closest('.size_popup-parent');
        var popup = sizePopupParent && sizePopupParent.querySelector('.product_listing_sizes-popup');
        if (popup) popup.classList.add('show_popup');
        return;
    }

    if (target.closest('.listing-popup_cross_btn svg')) {
        var sizePopupParent2 = target.closest('.size_popup-parent');
        var popup2 = sizePopupParent2 && sizePopupParent2.querySelector('.product_listing_sizes-popup');
        if (popup2) popup2.classList.remove('show_popup');
        return;
    }

    if (target.classList.contains("menu-drawer__menu-item") || target.classList.contains("inner_menu_svg")) {
        document.querySelectorAll(".mobile-sidebar_images_wrapp").forEach(function(element) {
            element.style.display = "none";
        });
    }

    if (target.classList.contains("first_menu_data") || target.classList.contains("custom_top_icon")) {
        document.querySelectorAll(".mobile-sidebar_images_wrapp").forEach(function(element) {
            element.style.display = "none";
        });
        var parentLi = target.closest("li");
        if (!parentLi) return;
        var dataHandle = parentLi.getAttribute("data-handle");
        var sidebarForHandle = document.querySelector(".mobile-sidebar_images_wrapp[data-handle='" + dataHandle + "']");
        if (parentLi.classList.contains("activemonile-menu")) {
            if (sidebarForHandle) {
                sidebarForHandle.style.display = "block";
                if (!sidebarForHandle.classList.contains("swiper-container-initialized")) {
                    new Swiper(sidebarForHandle, {
                        loop: true,
                        slidesPerView: 1,
                        spaceBetween: 10,
                        autoplay: { delay: 5000 }
                    });
                }
            }
        } else if (sidebarForHandle) {
            sidebarForHandle.style.display = "none";
        }
        return;
    }

    if (target.closest('.wishlist-hero-custom-button.wishlisthero-floating button svg')) {
        setTimeout(function() {
            if (typeof window.WishListHero_SDK === 'undefined') return;
            var countEl = document.querySelector(".wishlist-hero-items-count");
            if (!countEl) return;
            var wishlist_item_count = window.WishListHero_SDK.GetWishListItemsCount();
            countEl.style.display = wishlist_item_count > 0 ? "block" : "none";
            countEl.innerHTML = wishlist_item_count;
        }, 1200);
        return;
    }

    var cartOverlay = document.querySelector("div#CartDrawer-Overlay");
    if (cartOverlay && target === cartOverlay) {
        document.body.classList.remove("overflow-hidden");
        return;
    }

    var crossSvg = document.querySelector(".cross_ccureency-swicher-wrapper .mobile-menu-cross-wrapper svg");
    var crossmain = document.querySelector(".cross_ccureency-swicher-wrapper .mobile-menu-cross-wrapper");
    if (target === crossSvg || target === crossmain) {
        var menuSummary = document.querySelector(".menu-opening summary");
        if (menuSummary) menuSummary.click();
        setTimeout(function() {
            var activeLi = document.querySelector("li.mainLiList.activemonile-menu");
            if (!activeLi) return;
            var dataHandle = activeLi.getAttribute("data-handle");
            var sidebarForHandle = document.querySelector(".mobile-sidebar_images_wrapp[data-handle='" + dataHandle + "']");
            if (sidebarForHandle) sidebarForHandle.style.display = "block";
        }, 100);
    }
});

var closeButtonElements = document.querySelectorAll(".menu-drawer__close-button");
closeButtonElements.forEach(function(closeButtonElement) {
    closeButtonElement.addEventListener("click", function() {
        setTimeout(function() {
            var activeLi = document.querySelector("li.mainLiList.activemonile-menu");
            if (!activeLi) return;
            var dataHandle = activeLi.getAttribute("data-handle");
            var sidebarForHandle = document.querySelector(".mobile-sidebar_images_wrapp[data-handle='" + dataHandle + "']");
            if (sidebarForHandle) sidebarForHandle.style.display = "block";
        }, 100);
    });
});

function validateEmail() {
    var emailInput = document.getElementById("NewsletterForm--email");
    var errorEl = document.getElementById("emailError");
    var subscribeBtn = document.getElementById("Subscribe");
    var fieldWrapper = document.querySelector(".newsletter-form__field-wrapper");
    if (!emailInput || !errorEl || !subscribeBtn || !fieldWrapper) return;

    var email = emailInput.value;
    var value_length = email.length;
    if (value_length > 0) {
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(email)) {
            errorEl.innerText = "";
            subscribeBtn.removeAttribute("disabled");
            fieldWrapper.classList.remove("show_error_msg");
        } else {
            fieldWrapper.classList.add("show_error_msg");
            errorEl.innerText = "*Please include an @ in the email address";
            subscribeBtn.setAttribute("disabled", "disabled");
        }
    } else {
        errorEl.innerText = "";
        subscribeBtn.removeAttribute("disabled");
        fieldWrapper.classList.remove("show_error_msg");
    }
}

var headings = document.querySelectorAll(".footer-block--menu .footer-block__heading");
headings.forEach(function(heading) {
    heading.addEventListener("click", function() {
        this.parentNode.classList.toggle("active_acco");
    });
});

var resizeDebounceTimer;
window.addEventListener('resize', function() {
    clearTimeout(resizeDebounceTimer);
    resizeDebounceTimer = setTimeout(function() {
        var doublyWrapper = document.querySelector(".doubly-wrapper");
        if (!doublyWrapper) return;
        if (window.innerWidth < 990) {
            var mobileLocalizationWrapper = document.querySelector(".mobile-localization-wrapper");
            if (mobileLocalizationWrapper) {
                mobileLocalizationWrapper.parentNode.insertBefore(doublyWrapper, mobileLocalizationWrapper.nextSibling);
            }
        } else {
            var cartIconBubble = document.querySelector("a#cart-icon-bubble");
            if (cartIconBubble) {
                cartIconBubble.parentNode.insertBefore(doublyWrapper, cartIconBubble.nextSibling);
            }
        }
    }, 150);
});